
import { focusStyle } from '../../styles/mixins';
import { createStyles, makeUiStyles, Theme } from '../../styles/styles';
import { TextFieldSize } from '../TextField/tools/TextField.const';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles<Theme, { isFilled?: boolean, size?: TextFieldSize }>((theme: Theme) => createStyles({
  clearIconButton: {
    color: theme.color.greys[80],
    transition: 'opacity 0.3s ease',
    opacity: ({ isFilled }) => isFilled ? 1 : 0,
    pointerEvents: ({ isFilled }) => isFilled ? 'auto' : 'none',
    '&:focus-visible': {
      ...focusStyle(theme)
    },
  },
  clearIcon: {
    width: 24,
    height: 24,
  },
  magnifyingGlass: {
    width: ({ size }) => size === TextFieldSize.SMALL ? 16 : 24,
    height: ({ size }) => size === TextFieldSize.SMALL ? 16 : 24,
  }
}), { name: 'SearchField', index: StylesIndexInjections.UI_MOLECULES });
